import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PredefinedDateRanges from "../../../core/common/datePicker";
import { expenseDetails } from "../../../core/data/json/expenseDetails";
import Table from "../../../core/common/dataTable/index";
import { Card, Select, TableProps } from "antd";
import ReactApexChart from "react-apexcharts";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "antd";
import {
    fetchAllTimeSheetCount,
    fetchAllWorkingHoursMonthly,
    fetchAllEmployeeData,
    fetchAllLogByemployeeId
} from "../../../core/data/redux/reports/timesheet_report/timesheet.Action";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../../core/data/redux/store";
import {
    exportToCSV,
    exportToExcel,
} from "../../../core/common/GlobalFunctions/exportTableData";
import { CaretRightOutlined } from "@ant-design/icons";
import type { ColumnsType } from "antd/es/table";
import { getEmployees } from "../../../core/data/redux/employee/employeeAction";
import { fetchAllProjects } from "../../../core/data/redux/projects/project/projectAction";
import { Option } from "antd/es/mentions";

interface EmployeeData {
    key: string;
    employee_name: string;
    PictureURL: string;
    work_date: string;
    project_name: string;
    total_hours: number;
    hours_logged: number;
    deadline: string;
    status: string;
}

interface Props {
    data: EmployeeData[];
}

const statusClassMap: Record<string, string> = {
    "In Progress": "badge-warning",
    Completed: "badge-success",
    Pending: "badge-secondary",
};

const formatDate = (date: string) =>
    new Date(date).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });

const detailCellStyle = {
    padding: "8px",
    border: "1px solid #E9EDF4",
    fontSize: "14px",
};

interface TimeSheetReportlogProps {
  showOnlyTable?: boolean;
}

const TimeSheetReportlog: React.FC<TimeSheetReportlogProps> = ({ showOnlyTable}) => {
    const dispatch = useDispatch<AppDispatch>();
    const [countDetails, setcountDetails] = useState<any>(null);
    const [selectedYear, setSelectedYear] = useState("2025");
    const [employeeData, setemployeeData] = useState<any>(null);
    console.log(employeeData, 'employeeData');
    const [expandedRows, setExpandedRows] = useState<Set<string>>(new Set());
    const { employees } = useSelector((state: any) => state.employee);
    const { projectsData } = useSelector((state: any) => state.project.projects);

    useEffect(() => {
        if (!employees.length) {
            dispatch(getEmployees());
        }
    }, [employees.length, dispatch]);

    const toggleRow = (employeeName: string) => {
        const updated = new Set(expandedRows);
        if (updated.has(employeeName)) {
            updated.delete(employeeName);
        } else {
            updated.add(employeeName);
        }
        setExpandedRows(updated);
    };

    useEffect(() => {
        dispatch(fetchAllWorkingHoursMonthly(selectedYear)).then((res) => {
            console.log(res.payload.data);
        });
        dispatch(fetchAllTimeSheetCount()).then((res) => {
            setcountDetails(res.payload.data);
        });
        // dispatch(fetchAllEmployeeData())
        //     .then((res) => {
        //         setemployeeData(res.payload.data)
        //     })
        dispatch(getEmployees());
        dispatch(fetchAllProjects());
    }, []);





    const thStyle: React.CSSProperties = {
        padding: "12px 15px",
        fontWeight: "bold",
        borderBottom: "2px solid #ddd",
        whiteSpace: "nowrap",
    };

    const tdStyle: React.CSSProperties = {
        padding: "10px 15px",
        borderBottom: "1px solid #ddd",
        whiteSpace: "nowrap",
    };



    useEffect(() => {
        dispatch(fetchAllWorkingHoursMonthly(selectedYear)).then((res) => {
            const monthlyData = res.payload.data;

            const workingHoursPerMonth = new Array(12).fill(0);

            if (monthlyData && monthlyData.length > 0) {
                monthlyData.forEach(({ month, total_hours_logged }: any) => {
                    const monthIndex = month - 1;
                    workingHoursPerMonth[monthIndex] = parseFloat(total_hours_logged);
                });
            }

            setExpensechart((prev: any) => ({
                ...prev,
                series: [
                    {
                        ...prev.series[0],
                        data: workingHoursPerMonth,
                    },
                ],
            }));
        });
    }, [selectedYear]);


    const handleEmployeeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const employeeId = e.target.value;
        setSelectedEmployee(employeeId);

        if (employeeId) {
            dispatch(fetchAllLogByemployeeId(employeeId))
                .then((res) => {
                    setemployeeData(res.payload.data)
                })
        }
    };



    function formatWorkEntries(data: any) {
        if (!Array.isArray(data)) {
            return [];
        }

        return data.map(entry => ({
            employeeName: entry?.Name ?? "Unknown",
            projectName: entry?.project_name ?? "N/A",
            workDate: entry?.work_date ? entry.work_date.split("T")[0] : null,
            deadline: entry?.deadline ? entry.deadline.split("T")[0] : null,
            totalHours: parseFloat(entry?.total_hours ?? "0"),
            hoursLogged: parseFloat(entry?.hours_logged ?? "0"),
            status: entry?.status ?? "",
            requestStatus: entry?.requestStatus ?? "",
        }));
    }


    const data = formatWorkEntries(employeeData)

    const handleYearSelect = (year: any) => {
        setSelectedYear(year);
    };

    const headerStyle = {
        color: "#111827",
        fontWeight: 600,
        background: "#E5E7EB",
        borderBottom: "1px solid #E9EDF4",
        fontSize: "14px",
        padding: "12px", // optional for spacing
        textAlign: "center",
    };



    //New Chart
    const [expensechart, setExpensechart] = useState<any>({
        series: [
            {
                name: "Working Hrs",
                data: new Array(12).fill(0),
            },
        ],
        chart: {
            height: 190,
            type: "area",
            zoom: {
                enabled: false,
            },
        },
        colors: ["#FF9F43"],
        dataLabels: {
            enabled: false,
        },
        stroke: {
            curve: "smooth",
        },
        title: {
            text: "",
            align: "left",
        },
        // grid: {
        //   row: {
        //     colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
        //     opacity: 0.5
        //   },
        // },
        xaxis: {
            categories: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec",
            ],
        },
        yaxis: {
            min: 1,
            max: 200,
            tickAmount: 5,
            labels: {
                offsetX: -15,
                formatter: (val: number) => {
                    return val / 1 + "Hr";
                },
            },
        },
        legend: {
            position: "top",
            horizontalAlign: "left",
        },
    });


    const [selectedEmployee, setSelectedEmployee] = useState<any>(null);


if (showOnlyTable) {
  return (
            <div className="card">
                        <div className="mb-4">
                            <label
                                htmlFor="employeeSelect"
                                className="block text-sm font-medium text-gray-700 mb-2"
                            >
                                Select Employee:
                            </label>

                            <select
                                id="employeeSelect"
                                value={selectedEmployee}
                                onChange={handleEmployeeChange}
                                className="block w-full px-4 py-2 border border-gray-300 rounded-xl shadow-sm 
      focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 
      bg-white text-gray-700 font-medium transition duration-200"
                            >
                                <option value="">-- Choose Employee --</option>
                                {employees.map((emp: any) => (
                                    <option key={emp.EmployeeID} value={emp.EmployeeID}>
                                        {emp.Name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div style={{ overflowX: "auto", marginTop: "20px" }}>
                            <table
                                style={{
                                    borderCollapse: "collapse",
                                    width: "100%",
                                    minWidth: "1400px",
                                    backgroundColor: "#fff",
                                    borderRadius: "10px",
                                    overflow: "hidden",
                                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                                }}
                            >
                                <thead>
                                    <tr style={{ backgroundColor: "#4CAF50", color: "#fff", textAlign: "left" }}>
                                        <th style={thStyle}>Work ID</th>
                                        <th style={thStyle}>Project ID</th>
                                        <th style={thStyle}>Project Name</th>
                                        <th style={thStyle}>Tasks Name</th>
                                        <th style={thStyle}>Employee Name</th>
                                        <th style={thStyle}>Deadline</th>
                                        <th style={thStyle}>Total Hours</th>
                                        <th style={thStyle}>Remaining Hours</th>
                                        <th style={thStyle}>Work Date</th>
                                        <th style={thStyle}>Hours Logged</th>
                                        <th style={thStyle}>Status</th>
                                        <th style={thStyle}>Description</th>
                                        <th style={thStyle}>Request Status</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {employeeData?.map((item: any, index: number) => (
                                        <>
                                            {/* ------------------ PARENT ROW ------------------ */}
                                            <tr
                                                key={`parent-${index}`}
                                                style={{
                                                    backgroundColor: index % 2 === 0 ? "#f3fff3" : "#fff",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                <td style={tdStyle}>—</td>
                                                <td style={tdStyle}>—</td>
                                                <td style={tdStyle}>{item.project_name}</td>
                                                <td style={tdStyle}></td>
                                                <td style={tdStyle}>{item.employee_name}</td>
                                                <td style={tdStyle}>{new Date(item.deadline).toLocaleDateString()}</td>
                                                <td style={tdStyle}>{item.total_hours}</td>
                                                <td style={tdStyle}>{item.remaining_hours}</td>
                                                <td style={tdStyle}>{new Date(item.work_date).toLocaleDateString()}</td>
                                                <td style={tdStyle}>{item.hours_logged}</td>
                                                <td style={{ ...tdStyle, color: "green" }}>{item.status}</td>
                                                <td style={tdStyle}>—</td>
                                                <td style={{ ...tdStyle, color: "orange" }}>{item.requestStatus}</td>
                                            </tr>

                                            {/* ------------------ CHILD DETAIL ROWS ------------------ */}
                                            {item.details?.map((d: any, i: number) => (
                                                <tr
                                                    key={`detail-${index}-${i}`}
                                                    style={{
                                                        backgroundColor: "#fafafa",
                                                        borderLeft: "4px solid #4CAF50",
                                                    }}
                                                >
                                                    <td style={tdStyle}>{d.work_id}</td>
                                                    <td style={tdStyle}>{d.project_id}</td>
                                                    <td style={tdStyle}>{d.project_name}</td>
                                                    <td style={tdStyle}>{d.Title}</td>
                                                    <td style={tdStyle}>{item.employee_name}</td>
                                                    <td style={tdStyle}>
                                                        {new Date(d.deadline).toLocaleDateString()}
                                                    </td>
                                                    <td style={tdStyle}>{d.total_hours}</td>
                                                    <td style={tdStyle}>{d.remaining_hours}</td>
                                                    <td style={tdStyle}>
                                                        {new Date(d.work_date).toLocaleDateString()}
                                                    </td>
                                                    <td style={tdStyle}>{d.hours_logged}</td>
                                                    <td style={tdStyle}>{d.status}</td>
                                                    <td style={tdStyle}>{d.description}</td>
                                                    <td style={tdStyle}>{d.requestStatus}</td>
                                                </tr>
                                            ))}
                                        </>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
  );
}

    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">TimeSheetLog Report</h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to="index.html">
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">administration</li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        TimeSheetLog Report
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                            <div className="mb-2">
                                <div className="dropdown">
                                    <Link
                                        to="#"
                                        className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                                        data-bs-toggle="dropdown"
                                    >
                                        <i className="ti ti-file-export me-1" />
                                        Export
                                    </Link>
                                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                                        <li>
                                            <button
                                                onClick={() => exportToCSV(data, "TimeSheet_report")}
                                                className="dropdown-item rounded-1"
                                            >
                                                <i className="ti ti-file-type-pdf me-1" />
                                                Export as CSV
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                onClick={() => exportToExcel(data, "TimeSheet_report")}
                                                className="dropdown-item rounded-1"
                                            >
                                                <i className="ti ti-file-type-xls me-1" />
                                                Export as Excel{" "}
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="head-icons ms-2">
                                <CollapseHeader />
                            </div>
                        </div>
                    </div>
                    {/* /Breadcrumb */}
                    <div className="row">
                        {/* Total Exponses */}
                        <div className="col-xl-6 d-flex">
                            <div className="row flex-fill">
                                <div className="col-md-6 d-flex">
                                    <div className="card flex-fill position-relative">
                                        <span className="position-absolute start-0 bottom-0">
                                            <ImageWithBasePath
                                                src="assets/img/reports-img/total-expense.svg"
                                                alt="img"
                                                className="img-fluid"
                                            />
                                        </span>
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between mb-2">
                                                <div>
                                                    <span className="fs-14 fw-normal text-truncate mb-1">
                                                        Total Project
                                                    </span>
                                                    <h5>{countDetails?.[0].total_projects}</h5>
                                                </div>
                                                <Link
                                                    to="#"
                                                    className="avatar avatar-md avatar-rounded bg-transparent-primary border border-primary"
                                                >
                                                    <span className="text-primary">
                                                        <i className="ti ti-folders" />
                                                    </span>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 d-flex">
                                    <div className="card flex-fill position-relative">
                                        <span className="position-absolute start-0 bottom-0">
                                            <ImageWithBasePath
                                                src="assets/img/reports-img/approved-expense.svg"
                                                alt="img"
                                                className="img-fluid"
                                            />
                                        </span>
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between mb-2">
                                                <div>
                                                    <span className="fs-14 fw-normal text-truncate mb-1">
                                                        Completed Projects
                                                    </span>
                                                    <h5>{countDetails?.[0].completed_projects}</h5>
                                                </div>
                                                <Link
                                                    to="#"
                                                    className="avatar avatar-md avatar-rounded bg-transparent-success border border-success"
                                                >
                                                    <span className="text-success">
                                                        <i className="ti ti-layout" />
                                                    </span>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 d-flex">
                                    <div className="card flex-fill position-relative">
                                        <span className="position-absolute start-0 bottom-0">
                                            <ImageWithBasePath
                                                src="assets/img/reports-img/pending-expense.svg"
                                                alt="img"
                                                className="img-fluid"
                                            />
                                        </span>
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between mb-2">
                                                <div>
                                                    <span className="fs-14 fw-normal text-truncate mb-1">
                                                        In-Progress Project
                                                    </span>
                                                    <h5>{countDetails?.[0].in_progress_projects}</h5>
                                                </div>
                                                <Link
                                                    to="#"
                                                    className="avatar avatar-md avatar-rounded bg-transparent-skyblue border border-skyblue"
                                                >
                                                    <span className="text-skyblue">
                                                        <i className="ti ti-briefcase" />
                                                    </span>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 d-flex">
                                    <div className="card flex-fill position-relative">
                                        <span className="position-absolute start-0 bottom-0">
                                            <ImageWithBasePath
                                                src="assets/img/reports-img/reject-expense.svg"
                                                alt="img"
                                                className="img-fluid"
                                            />
                                        </span>
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between mb-2">
                                                <div>
                                                    <span className="fs-14 fw-normal text-truncate mb-1">
                                                        Pending Project
                                                    </span>
                                                    <h5>{countDetails?.[0].pending_projects}</h5>
                                                </div>
                                                <Link
                                                    to="#"
                                                    className="avatar avatar-md avatar-rounded bg-transparent-danger border border-danger"
                                                >
                                                    <span className="text-danger">
                                                        <i className="ti ti-layout" />
                                                    </span>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* /Total Exponses */}
                        {/* Total Exponses */}
                        <div className="col-xl-6 d-flex">
                            <div className="card flex-fill">
                                <div className="card-header border-0 pb-0">
                                    <div className="d-flex flex-wrap justify-content-between align-items-center">
                                        <div className="d-flex align-items-center ">
                                            <span className="me-2">
                                                <i className="ti ti-chart-area-line text-danger" />
                                            </span>
                                            <h5>TimeSpend</h5>
                                        </div>
                                        <div className="dropdown">
                                            <Link
                                                to="#"
                                                className="dropdown-toggle btn btn-sm fs-12 btn-white d-inline-flex align-items-center"
                                                data-bs-toggle="dropdown"
                                            >
                                                {selectedYear}
                                            </Link>
                                            <ul className="dropdown-menu  dropdown-menu-end p-2">
                                                <li>
                                                    <Link
                                                        to="#"
                                                        className="dropdown-item rounded-1"
                                                        onClick={() => handleYearSelect("2025")}
                                                    >
                                                        2025
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link
                                                        to="#"
                                                        className="dropdown-item rounded-1"
                                                        onClick={() => handleYearSelect("2024")}
                                                    >
                                                        2024
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link
                                                        to="#"
                                                        className="dropdown-item rounded-1"
                                                        onClick={() => handleYearSelect("2023")}
                                                    >
                                                        2023
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body py-0">
                                    <ReactApexChart
                                        id="expense-analysis"
                                        options={expensechart}
                                        series={expensechart.series}
                                        type="area"
                                        height={193}
                                    />
                                </div>
                            </div>
                        </div>
                        {/* /Total Exponses */}
                    </div>
                    <div className="card">
                        <div className="mb-4">
                            <label
                                htmlFor="employeeSelect"
                                className="block text-sm font-medium text-gray-700 mb-2"
                            >
                                Select Employee:
                            </label>

                            <select
                                id="employeeSelect"
                                value={selectedEmployee}
                                onChange={handleEmployeeChange}
                                className="block w-full px-4 py-2 border border-gray-300 rounded-xl shadow-sm 
      focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 
      bg-white text-gray-700 font-medium transition duration-200"
                            >
                                <option value="">-- Choose Employee --</option>
                                {employees.map((emp: any) => (
                                    <option key={emp.EmployeeID} value={emp.EmployeeID}>
                                        {emp.Name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div style={{ overflowX: "auto", marginTop: "20px" }}>
                            <table
                                style={{
                                    borderCollapse: "collapse",
                                    width: "100%",
                                    minWidth: "1400px",
                                    backgroundColor: "#fff",
                                    borderRadius: "10px",
                                    overflow: "hidden",
                                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                                }}
                            >
                                <thead>
                                    <tr style={{ backgroundColor: "#4CAF50", color: "#fff", textAlign: "left" }}>
                                        <th style={thStyle}>Work ID</th>
                                        <th style={thStyle}>Project ID</th>
                                        <th style={thStyle}>Project Name</th>
                                        <th style={thStyle}>Tasks Name</th>
                                        <th style={thStyle}>Employee Name</th>
                                        <th style={thStyle}>Deadline</th>
                                        <th style={thStyle}>Total Hours</th>
                                        <th style={thStyle}>Remaining Hours</th>
                                        <th style={thStyle}>Work Date</th>
                                        <th style={thStyle}>Hours Logged</th>
                                        <th style={thStyle}>Status</th>
                                        <th style={thStyle}>Description</th>
                                        <th style={thStyle}>Request Status</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {employeeData?.map((item: any, index: number) => (
                                        <>
                                            {/* ------------------ PARENT ROW ------------------ */}
                                            <tr
                                                key={`parent-${index}`}
                                                style={{
                                                    backgroundColor: index % 2 === 0 ? "#f3fff3" : "#fff",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                <td style={tdStyle}>—</td>
                                                <td style={tdStyle}>—</td>
                                                <td style={tdStyle}>{item.project_name}</td>
                                                <td style={tdStyle}></td>
                                                <td style={tdStyle}>{item.employee_name}</td>
                                                <td style={tdStyle}>{new Date(item.deadline).toLocaleDateString()}</td>
                                                <td style={tdStyle}>{item.total_hours}</td>
                                                <td style={tdStyle}>{item.remaining_hours}</td>
                                                <td style={tdStyle}>{new Date(item.work_date).toLocaleDateString()}</td>
                                                <td style={tdStyle}>{item.hours_logged}</td>
                                                <td style={{ ...tdStyle, color: "green" }}>{item.status}</td>
                                                <td style={tdStyle}>—</td>
                                                <td style={{ ...tdStyle, color: "orange" }}>{item.requestStatus}</td>
                                            </tr>

                                            {/* ------------------ CHILD DETAIL ROWS ------------------ */}
                                            {item.details?.map((d: any, i: number) => (
                                                <tr
                                                    key={`detail-${index}-${i}`}
                                                    style={{
                                                        backgroundColor: "#fafafa",
                                                        borderLeft: "4px solid #4CAF50",
                                                    }}
                                                >
                                                    <td style={tdStyle}>{d.work_id}</td>
                                                    <td style={tdStyle}>{d.project_id}</td>
                                                    <td style={tdStyle}>{d.project_name}</td>
                                                    <td style={tdStyle}>{d.Title}</td>
                                                    <td style={tdStyle}>{item.employee_name}</td>
                                                    <td style={tdStyle}>
                                                        {new Date(d.deadline).toLocaleDateString()}
                                                    </td>
                                                    <td style={tdStyle}>{d.total_hours}</td>
                                                    <td style={tdStyle}>{d.remaining_hours}</td>
                                                    <td style={tdStyle}>
                                                        {new Date(d.work_date).toLocaleDateString()}
                                                    </td>
                                                    <td style={tdStyle}>{d.hours_logged}</td>
                                                    <td style={tdStyle}>{d.status}</td>
                                                    <td style={tdStyle}>{d.description}</td>
                                                    <td style={tdStyle}>{d.requestStatus}</td>
                                                </tr>
                                            ))}
                                        </>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
                <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
                    <p className="mb-0">2024 - 2025© hrmtree.</p>
                    <p>
                        Developed By{" "}
                        <Link to="#" className="text-primary">
                            Leadchain Systems
                        </Link>
                    </p>
                </div>
            </div>
            {/* /Page Wrapper */}
        </>
    );
};

export default TimeSheetReportlog;
